<script setup lang="ts">
/**
 * GlobalConfirmDialog — 全局确认弹窗宿主
 *
 * 把 useGlobalConfirmStore 的状态桥接到 MeowChat 风格的 ConfirmDialog。
 * 在应用根部（App.vue）挂一次即可，任何非组件上下文都能通过
 * useGlobalConfirmStore().confirm(...) 弹出并 await 结果。
 */
import { storeToRefs } from 'pinia'

import ConfirmDialog from './ConfirmDialog.vue'

import { useGlobalConfirmStore } from '../../stores/global-confirm'

const store = useGlobalConfirmStore()
const { show, title, message, confirmText, cancelText, confirmVariant } = storeToRefs(store)
</script>

<template>
  <ConfirmDialog
    :show="show"
    :title="title"
    :message="message"
    :confirm-text="confirmText"
    :cancel-text="cancelText"
    :confirm-variant="confirmVariant"
    @confirm="store.handleConfirm"
    @cancel="store.handleCancel"
  />
</template>
